// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"BackgroundCheckModal_modalButtons__3AWhl","modalButton":"BackgroundCheckModal_modalButton__21WA2","cancelButton":"BackgroundCheckModal_cancelButton__3Gu_Q"};